import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { SmartCampaignRoute } from '@/modules/ta/smartcampaign/smartcampaign.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${SmartCampaignRoute.SMARTCAMPAIGNS}`,
      name: 'smartcampaigns',
      component: () =>
        import(/* webpackChunkName: "smartcampaigns-page" */ './pages/SmartCampaignsPage.vue'),
    },
    {
      path: `/${SmartCampaignRoute.SMARTCAMPAIGNS}/new`,
      name: 'smartcampaignform:new',
      component: () =>
        import(
          /* webpackChunkName: "smartcampaign-form-page" */ './pages/SmartCampaignFormPage.vue'
        ),
    },
    {
      path: `/${SmartCampaignRoute.SMARTCAMPAIGNS}/:id`,
      name: 'smartcampaignform',
      component: () =>
        import(
          /* webpackChunkName: "smartcampaign-form-page" */ './pages/SmartCampaignFormPage.vue'
        ),
    },
  ],
  Module.SMARTCAMPAIGN
);
